import { render, staticRenderFns } from "./UniversityOperationsModal.vue?vue&type=template&id=08d30f02&scoped=true&"
import script from "./UniversityOperationsModal.vue?vue&type=script&lang=js&"
export * from "./UniversityOperationsModal.vue?vue&type=script&lang=js&"
import style0 from "./UniversityOperationsModal.vue?vue&type=style&index=0&id=08d30f02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d30f02",
  null
  
)

export default component.exports